/**
 * Quem esta logado, do ponto de vista da CASCA.
 *
 * O `Session` em `domain/session.ts` e o que o login devolve - token e papeis. Isto
 * aqui e o CADASTRO da pessoa, que a casca busca para o cabecalho e "Meus Dados"
 * busca para o formulario. Ver `restricted.api.ts`, ao lado.
 */
/**
 * Como a pessoa se chama: nome social se houver, senao nome e sobrenome.
 *
 * Vazio quando nao ha nada - quem chama decide o que por no lugar. O `Partial`
 * existe porque o legado ja devolveu profissional sem `user`.
 */
export function accountName(account) {
    if (!account) {
        return '';
    }
    return (account.socialName ?? '').trim() || `${account.firstName ?? ''} ${account.lastName ?? ''}`.trim();
}
//# sourceMappingURL=restricted.types.js.map